import { graphql } from '@/gql'

export const CreateCustomFieldMutation = graphql(/*GraphQl*/ `
  mutation CreateCustomField($input: CreateCustomFieldInput!) {
    createCustomField(input: $input) {
      ...CustomFieldDetail
    }
  }
`)

export const UpdateCustomFieldMutation = graphql(/*GraphQl*/ `
  mutation UpdateCustomField($input: UpdateCustomFieldInput!) {
    updateCustomField(input: $input) {
      ...CustomFieldDetail
    }
  }
`)

export const DeleteCustomFieldMutation = graphql(/*GraphQl*/ `
  mutation DeleteCustomField($input: DeleteCustomFieldInput!) {
    deleteCustomField(input: $input) {
      id
    }
  }
`)
